let openCount = 0;
let savedScrollY = 0;
let savedBodyStyles = null;

export function lockDrawerScroll() {
  openCount += 1;
  if (openCount > 1) return;

  savedScrollY = window.scrollY;
  const body = document.body;

  savedBodyStyles = {
    position: body.style.position,
    top: body.style.top,
    width: body.style.width,
    overflow: body.style.overflow,
  };

  body.classList.add('no-scroll');
  body.style.position = 'fixed';
  body.style.top = `-${savedScrollY}px`;
  body.style.width = '100%';
  body.style.overflow = 'hidden';
}

export function unlockDrawerScroll() {
  if (openCount === 0) return;

  openCount -= 1;
  if (openCount > 0) return;

  const body = document.body;
  body.classList.remove('no-scroll');

  if (savedBodyStyles) {
    body.style.position = savedBodyStyles.position;
    body.style.top = savedBodyStyles.top;
    body.style.width = savedBodyStyles.width;
    body.style.overflow = savedBodyStyles.overflow;
    savedBodyStyles = null;
  } else {
    body.style.position = '';
    body.style.top = '';
    body.style.width = '';
    body.style.overflow = '';
  }

  window.scrollTo(0, savedScrollY);
}
